// extracted by mini-css-extract-plugin
module.exports = {"pt-adult-stock-list":"pt-adult-stock-list-af9638e98d0ffc02068ba970a014f792"};